import "core-js/modules/es.number.constructor";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var CalendarPaneDay = /*#__PURE__*/function (_Vue) {
  _inherits(CalendarPaneDay, _Vue);

  var _super = _createSuper(CalendarPaneDay);

  function CalendarPaneDay() {
    _classCallCheck(this, CalendarPaneDay);

    return _super.apply(this, arguments);
  }

  return CalendarPaneDay;
}(Vue);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], CalendarPaneDay.prototype, "inMonth", void 0);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], CalendarPaneDay.prototype, "highlight", void 0);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], CalendarPaneDay.prototype, "isDisable", void 0);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], CalendarPaneDay.prototype, "active", void 0);

__decorate([Prop({
  type: String,
  required: true
})], CalendarPaneDay.prototype, "dayLabel", void 0);

__decorate([Prop({
  type: Number,
  default: function _default() {
    return 0;
  }
})], CalendarPaneDay.prototype, "badge", void 0);

CalendarPaneDay = __decorate([Component], CalendarPaneDay);
export default CalendarPaneDay;